import {
  Grid,
  Paper,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import {
  startTransition,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Table } from "reactstrap";
import SurveyService from "../Services/SurveyService";
import SurveyModel from "../Models/Survey/SurveyModel";
import SurveyInfo from "../Pages/Survey/SurveyInfo";
import { useNavigate } from "react-router-dom";
import { formatColumnDateWithTime } from "./Helpers";

export function OpenSurveys(props: { contactSsin?: string }) {
  const { t, i18n } = useTranslation("home");
  const navigate = useNavigate();

  const surveyService = useMemo(() => new SurveyService(), []);

  const [openSurveys, setOpenSurveys] = useState<SurveyModel[]>();

  const loadOpenSurveys = useCallback(async () => {
    try {
      if (props.contactSsin) {
        const data = await surveyService.getOpenSurveys(
          props.contactSsin ?? "",
          i18n.language
        );

        setOpenSurveys(data);
      }
    } catch (error: any) {
      toast.error(error);
    }
  }, [props.contactSsin, surveyService, i18n.language]);

  useEffect(() => {
    async function loadData() {
      await loadOpenSurveys();
    }

    loadData();
  }, []);

  return (
    <Grid p={5} item xs={12} md={4}>
      <Paper
  sx={{
    width: {
      xs: 250,   
      sm: 400,     
      md: 500     
    },
    maxWidth: '100%',
    margin: '0 auto'
  }}
  elevation={3}
>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  style={{ fontWeight: "bold" }}
                  colSpan={3}
                >
                  {t("Open vragenlijsten")}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {openSurveys !== undefined && openSurveys?.length > 0 ? (
                openSurveys.map((survey) => {
                  return (
                    <TableRow
                      key={survey.id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell
                        onClick={() => {
                          localStorage.removeItem("surveyid");
                          startTransition(() => {
                            navigate("/survey", {
                              state: {
                                surveyType: {
                                  surveyTypeId: survey.surveyTypeId,
                                  name: survey.surveyTypeName,
                                  surveyId: survey.id,
                                },
                                //accountId: props.accountId,
                                //contactId: props.contactId,
                              },
                            });
                          });
                        }}
                        align="left"
                        width="80%"
                        component="th"
                        scope="row"
                        style={{
                          backgroundColor: "rgb(252,252,252)",
                          color: "black",
                          cursor: "pointer",
                        }}
                      >
                        <Typography variant="body2">
                          {survey.surveyTypeName}
                        </Typography>
                        <Typography variant="body2">
                          <sub>
                            ({t("gestart op")}{" "}
                            {formatColumnDateWithTime(survey.startDateTime)})
                          </sub>
                        </Typography>
                      </TableCell>
                      <TableCell
                        align="center"
                        width="10%"
                        style={{
                          backgroundColor: "rgb(252,252,252)",
                          color: "black",
                        }}
                      >
                        <SurveyInfo
                          surveyTypeId={survey.surveyTypeId ?? ""}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell align="center" width="100%">
                    {t("Geen open vragenlijsten gevonden.")}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Grid>
  );
}
